import React, {
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useReducer,
} from 'react'
import { showConfirm, showDialog } from '../../_helpers/util'
import classes from './FileUploader.module.scss'

import UTIF from 'utif'
import AlertType from '../../Constants/AlertType'
import ImageViewer from './ImageViewer'
import { useSelector } from 'react-redux'
import { getTranslate } from '../Phrase/PhraseSlice'

const FileUploaderReducer = (state, action) => {
  switch (action.type) {
    case 'ADD':
      return [...state, action.payload]
    case 'DELETE':
      return state.filter((item) => item !== action.payload)
    case 'RESET':
      return (state = [])
    default:
      return state
  }
}

const FileUploader = (
  {
    canDelete = false,
    canUpload = true,
    imageStyle = { width: '50px', height: '50px' },
    accept = ['.jpg', '.png', '.tiff', '.pdf', '.zip'],
    name,
    onChangeImage,
    previousImages,
    uploadSize = 10485760, //1mb
    uploaderWrapperClassName,
    deleteHandler,
    multiple = true,
    isLocal = false,
    imageWrapperClassName,
    uploadLabelClassName,
    previousImageWrapperClassName,
  },
  ref
) => {
  const refUploadFile = useRef()
  const [previousImageValue, setPreviousImageValue] = useState([])
  const [isViewerOpen, setIsViewerOpen] = useState(false)
  const [currentImage, setCurrentImage] = useState(0)
  const [newAttachFiles, dispatchNewAttachFiles] = useReducer(
    FileUploaderReducer,
    []
  )
  const [hiddenSpinner, setHiddenSpinner] = useState(true)
  const [progress, setProgress] = useState(0)
  const [currentImageIsLocal, setcurrentImageIsLocal] = useState(0)
  const deleteImageFromPreviousImage = (index) => {
    // const showConfirmObject = {
    //   title: '',
    //   content: 'آیا از حذف فایل مطمئن هستید؟',
    //   type: AlertType.red,
    //   ,
    // }
    var yasAction = () => {
      let imageFiles = [...previousImageValue]
      const imgeDeletes = imageFiles.splice(index, 1)
      setPreviousImageValue(imageFiles)
      if (deleteHandler !== undefined) {
        deleteHandler(imgeDeletes[0])
      }
    }
    showConfirm('', 'آیا از حذف فایل مطمئن هستید؟', AlertType.red, yasAction)
  }

  useImperativeHandle(ref, () => {
    return {
      resetImageUploader: resetImageUploader,
      getFileUploader: () => {
        return newAttachFiles
      },
      getPreviousImages: () => {
        return previousImageValue
      },
    }
  })

  useEffect(() => {
    setPreviousImageValue(previousImages ?? [])
  }, [previousImages])

  useEffect(() => {
    if (onChangeImage !== undefined) {
      onChangeImage(newAttachFiles)
    }
  }, [newAttachFiles])

  const createImageSection = (
    imageList,
    isNew,
    deleteFunction,
    getImageFunction,
    className
  ) => {
    if (imageList === undefined || imageList.length === 0) return
    return imageList?.map((item, index) => {
      return (
        <div
          className={`border d-flex flex-column ${className} ${imageWrapperClassName}`}
          key={index}
        >
          <span>
            {canDelete && (
              <button
                type='button'
                className='close'
                aria-label='Close'
                onClick={() => deleteFunction(index)}
              >
                <span aria-hidden='true'>&times;</span>
              </button>
            )}
            <img
              width='100px'
              src={getImageFunction(item)}
              alt=''
              key={index}
              onClick={() => openImageViewer(item, isNew)}
            />
          </span>
        </div>
      )
    })
  }
  const openImageViewer = useCallback(
    (item, isNew) => {
      setCurrentImage(item)
      setIsViewerOpen(true)
      setcurrentImageIsLocal(isNew)
    },
    [newAttachFiles.length]
  )

  const deleteImage = (index) => {
    dispatchNewAttachFiles({ type: 'DELETE', payload: newAttachFiles[index] })
    refUploadFile.current.value = null
  }

  const resetImageUploader = () => {
    if (
      refUploadFile !== undefined &&
      refUploadFile.current !== undefined &&
      refUploadFile.current !== null
    ) {
      refUploadFile.current.value = null
      dispatchNewAttachFiles({ type: 'RESET' })
    }
  }

  function readFile(file) {
    const reader = new FileReader()

    reader.onprogress = (e) => {
      if (e.lengthComputable) {
        const percentLoaded = Math.round((e.loaded / e.total) * 100)
        setProgress(percentLoaded)
      }
    }
    reader.onload = (e2) => {
      if (file.type === 'image/tiff') {
        const fileContent = e2.target.result
        const ifds = UTIF.decode(fileContent)
        const _tiffs = ifds.map((ifd, index) => {
          UTIF.decodeImage(fileContent, ifd)
          var rgba = UTIF.toRGBA8(ifd)
          var canvas = document.createElement('canvas')
          canvas.width = ifd.width
          canvas.height = ifd.height
          const ctx = canvas.getContext('2d')
          const img = ctx.createImageData(ifd.width, ifd.height)
          img.data.set(rgba)
          ctx.putImageData(img, 0, 0)
          return canvas
        })
        _tiffs.forEach((canvas, index) => {
          canvas.toBlob(function (blob) {
            const file = new File([blob], `canvasImage${index}.png`, {
              type: 'image/png',
            })
            dispatchNewAttachFiles({ type: 'ADD', payload: file })
          })
        })
      } else if (
        file.type === 'application/pdf' ||
        file.type === 'application/x-zip-compressed'
      ) {
        const blob = new Blob([e2.target.result], {
          type: file.type,
        })
        const newFile = new File([blob], `${file.name}`, {
          type: file.type,
        })
        dispatchNewAttachFiles({ type: 'ADD', payload: newFile })
      } else dispatchNewAttachFiles({ type: 'ADD', payload: file })
    }
    reader.readAsArrayBuffer(file)
  }
  const loadFile = (event) => {
    setHiddenSpinner(false)
    setProgress(0)
    let sizeErrorCount = 0
    for (var x = 0; x < event.target.files.length; x++) {
      let file = event.target.files[x]
      //reader.readAsDataURL(file)
      if (uploadSize !== undefined && file.size > uploadSize) {
        //برا ی بررسی سایز فایل
        sizeErrorCount = sizeErrorCount + 1
        continue
      }
      readFile(file)
    }

    if (sizeErrorCount) {
      showDialog(
        'هشدار',
        `اندازه بعضی از فایل های بزرگتر از ${
          uploadSize !== undefined ? uploadSize / 1024 : ''
        } k می باشد`,
        'red',
        4000
      )
    }
  }

  const handlePaste = (event) => {
    const items = event.clipboardData.items
    let sizeErrorCount = 0
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      if (
        item.type?.indexOf('image') !== -1 ||
        item.type?.indexOf('compressed') !== -1 ||
        item.type?.indexOf('pdf') !== -1
      ) {
        const file = item.getAsFile()
        if (uploadSize !== undefined && file.size > uploadSize) {
          //برا ی بررسی سایز فایل
          sizeErrorCount = sizeErrorCount + 1
          continue
        }
        readFile(file)
      }
    }
    if (sizeErrorCount) {
      showDialog(
        'هشدار',
        `اندازه بعضی از فایل های بزرگتر از ${
          uploadSize !== undefined ? uploadSize / 1048576 : ''
        } mb می باشد`,
        'red',
        4000
      )
    }
  }
  const titleUploader = useSelector(
    getTranslate('AddNewQuestion_Btn_ChoosePicture')
  )
  function getImage(image) {
    return 'data:image/jpg;base64,' + image.content
  }
  return (
    <>
      <div
        className={`${classes['FileUploader-wrapper']} ${
          uploaderWrapperClassName ?? ''
        }`}
        onPaste={canUpload ? handlePaste : () => {}}
      >
        {canUpload && (
          <div>
            <label
              className={`${classes['upload-file']} ${
                uploadLabelClassName ?? ''
              }`}
              // title='انتخاب فایل'
              title={titleUploader}
            >
              <i>{titleUploader}</i>
              <input
                ref={refUploadFile}
                type='file'
                accept={accept.join(',')}
                onChange={loadFile}
                multiple={multiple}
                hidden
              />
            </label>
          </div>
        )}
        <div className={`${classes.gallery}`}>
          {createImageSection(
            previousImageValue,
            false,
            deleteImageFromPreviousImage,
            getImage,
            classes['old-image']
          )}
          {newAttachFiles &&
            createImageSection(
              newAttachFiles,
              true,
              deleteImage,
              URL.createObjectURL,
              classes['new-image']
            )}
        </div>
      </div>
      {isViewerOpen && (
        <ImageViewer
          currentImage={currentImage}
          isLocal={currentImageIsLocal}
          onClosHandler={() => setIsViewerOpen(!isViewerOpen)}
          isViewerOpen={isViewerOpen}
        />
      )}
      {progress !== 0 && progress !== 100 && (
        <progress value={progress} max='100'></progress>
      )}
    </>
  )
}
export default React.forwardRef(FileUploader)
